<template>
  <div>
    <div class="h3title">财务应付</div>
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList52">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="openDialog('yf')"
          >添加应付
        </el-button>
      </div>
    </div>
    <div class="glo_Table">
      <el-table
        header-align="center"
        ref="mytable51"
        :data="tableData51"
        border
        stripe
        @selection-change="handleSelectionChange51"
        show-summary
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard5">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          >
          </el-table-column>
        </template>
        <el-table-column label="操作" align="center" sortable min-width="80">
          <template slot-scope="scope">
            <div>
              <i
                @click="editDialog(scope.row, scope.$index, 'yf')"
                class="el-icon-edit iconsbtns iconsRight10"
              ></i>
              <i
                @click="delIconsYF(scope.$index)"
                class="el-icon-delete iconsbtns"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="h3title">财务应收</div>
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList52">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="openDialog('ys')"
          >添加应收
        </el-button>
      </div>
    </div>
    <div class="glo_Table">
      <el-table
        header-align="center"
        ref="mytable52"
        :data="tableData52"
        border
        stripe
        @selection-change="handleSelectionChange52"
        show-summary
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard5">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          >
          </el-table-column>
        </template>
        <el-table-column label="操作" align="center" sortable min-width="80">
          <template slot-scope="scope">
            <div>
              <i
                @click="editDialog(scope.row, scope.$index, 'ys')"
                class="el-icon-edit iconsbtns iconsRight10"
              ></i>
              <i
                @click="delIconsYS(scope.$index)"
                class="el-icon-delete iconsbtns"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 添加费项 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      :isAppend="true"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItems"
            prop="inoutStatus"
            label="收支类型:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.inoutStatus"
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="item in inoutStatusList"
                :key="item.val"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            style="width: 500px"
            class="dialogFormItems"
            label="*结算对象:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm.objectStatusType"
                placeholder="请选择"
                @change="changeObjestStatusYS"
              >
                <el-option
                  v-for="item in objectStatusList"
                  :key="item.key"
                  :label="item.val"
                  :value="item.key"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm.objectName"
                placeholder="请选择"
                remote
                :allow-create="dialogForm.objectStatusType == 'other'"
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            style="width: 500px"
            class="dialogFormItems"
            label="*费项:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm.itemCategoryId"
                placeholder="请选择"
                @change="changeItemCategoryId"
              >
                <el-option
                  v-for="item in categoryNameList"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm.itemServiceId"
                placeholder="请选择"
                @change="changeItemServiceId"
              >
                <el-option
                  v-for="item in CategoryServiceList"
                  :key="item.itemServiceId"
                  :label="item.title"
                  :value="item.itemServiceId + ''"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="paymentMethodConfDictId"
            label="付款方式:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.paymentMethodConfDictId"
              placeholder="请选择"
              @change="changePayMent1"
            >
              <el-option
                v-for="item in settlementMethodList"
                :key="item.confDictId"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="amount" label="金额:">
            <el-input
              v-model="dialogForm.amount"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";

export default {
  components: {
    myDialog,
  },
  props: {
    tableDataYF: {
      typeof: Array,
      default: [],
    },
    tableDataYS: {
      typeof: Array,
      default: [],
    },
  },
  watch: {
    tableDataYF: {
      handler(a, b) {
        console.log("应付列表", a);
        this.tableData51 = a;
      },
      deep: true,
    },
    tableDataYS: {
      handler(a, b) {
        console.log("应收列表", a);
        this.tableData52 = a;
      },
      deep: true,
    },
  },
  data() {
    return {
      tableData51: [],
      tableData52: [],
      delTb51: [],
      delTb52: [],
      inoutStatusList: [
        {
          name: "收入",
          val: "shou_ru:deal_status",
        },
        {
          name: "支出",
          val: "zhi_chu:deal_status",
        },
      ],
      //   费项类型
      direction_statusList: [
        {
          name: "收入",
          val: "shou:direction_status",
        },
        {
          name: "支出",
          val: "fu:direction_status",
        },
      ],
      rulesForm: {
        // objectStatusType: [
        //   { required: true, message: "请选择", trigger: ["blur", "change"] },
        // ],
        // itemCategoryId: [
        //   { required: true, message: "请选择", trigger: ["blur", "change"] },
        // ],
        paymentMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        amount: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "40%",
      dialogType: "",
      tableType: "",
      dialogForm: {
        // 弹窗表单数据
        amount: "",
        inoutStatus: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethodConfDictName: "", //付款方式名称(我自己加的)
      },

      // ==== 弹窗组件属性 end ====

      myTableHeard5: [
        {
          name: "费项",
          field: "itemServiceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "金额",
          field: "amount",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "结算对象",
          field: "objectName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "付款方式",
          field: "paymentMethod",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],

      objectStatusList: [],
      settlementMethodList: [],
      categoryNameList: [],
      CustomerListsYF: [], //对象列表
      CategoryServiceList: [],

      editIdx: 0,
    };
  },

  created() {},
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    //选择费项类型()
    changeItemCategoryId(e) {
      if (e) {
        let direction_status = ""; //direction_statusList
        if (this.tableType == "yf") {
          direction_status = "fu:direction_status";
        } else {
          direction_status = "shou:direction_status";
        }
        this.wtl_itemServiceListAll(e, direction_status);
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm.itemCategoryName = item.categoryName;
          }
        });
      } else {
        this.dialogForm.itemServiceId = "";
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },
    //选择费项
    changeItemServiceId(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm.amount = item.unitPrice;
            this.dialogForm.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e, directionStatus) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          this.CategoryServiceList = res.data.result || [];
        });
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogForm.objectNumber = item.number;
            // this.dialogForm.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },
    // 选择结算对象类型(
    changeObjestStatusYS(e) {
      console.log("eeee", e);
      this.dialogForm.objectName = "";
      if (e) {
        this.getObjectUserDownListYf();
        this.objectStatusList.forEach((item) => {
          if (item.key == e) {
            this.dialogForm.objectStatusConfDictId = item.confDictId;
          }
        });
      } else {
        this.dialogForm.objectName = "";
        this.dialogForm.objectNumber = "";
        this.dialogForm.objectStatusConfDictId = "";
      }
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      let objectStatusType = "";
      if (this.isShowDialog) {
        objectStatusType = this.dialogForm.objectStatusType;
      } else {
        objectStatusType = this.dialogForm2.objectStatusType;
      }

      this.$API
        .wtl_getObjectUserDownList({
          key: objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    //选择付款方式(应付弹窗)
    changePayMent1(e) {
      if (e) {
        this.settlementMethodList.forEach((item) => {
          if (item.confDictId == e) {
            this.dialogForm.paymentMethod = item.val;
          }
        });
      } else {
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },
    // 编辑应付
    editDialog(val, idx, type) {
      this.tableType = type;
      if (type == "yf") {
        this.dialogTitle = "编辑应付费项";
        this.dialogForm.inoutStatus = "zhi_chu:deal_status";
        // 应付
      } else if (type == "ys") {
        // 应收
        this.dialogTitle = "编辑应收费项";
        this.dialogForm.inoutStatus = "shou_ru:deal_status";
      }
      this.dialogType = "edit";
      this.editIdx = idx;
      this.getConfDictValDownList("settlement_method");
      this.itemCategorChoose(); //费型类型下拉列表

      this.$API
        .wtl_getConfDictValDownList({ dictType: "object_status" })
        .then((res) => {
          this.objectStatusList = res.data.result || [];
          this.objectStatusList.forEach((item) => {
            if (item.confDictId == this.dialogForm.objectStatusConfDictId) {
              console.log("item.confDictId", item.confDictId);
              this.dialogForm.objectStatusType = item.key;
            }
          });
        });
      // this.getConfDictValDownList("object_status"); //结算对象类型
      // if (this.dialogType == "edit") {
      //       this.objectStatusList.forEach((item) => {
      //         if (item.confDictId == this.dialogForm.objectStatusConfDictId) {
      //           this.dialogForm.objectStatusType = item.key;
      //         }
      //       });
      //     }
      this.changeItemCategoryId(val.itemCategoryId);

      this.$nextTick(() => {
        this.dialogForm = JSON.parse(JSON.stringify(val));
        this.isShowDialog = true;
      });
    },

    // 新建应付应收
    openDialog(val) {
      if (val == "yf") {
        this.dialogTitle = "新建应付费项";
        this.dialogForm.inoutStatus = "zhi_chu:deal_status";
        // 应付
      } else if (val == "ys") {
        // 应收
        this.dialogTitle = "新建应收费项";
        this.dialogForm.inoutStatus = "shou_ru:deal_status";
      }
      this.tableType = val;
      this.dialogType = "add";
      this.isShowDialog = true;
      this.itemCategorChoose(); //费型类型下拉列表
      this.getConfDictValDownList("object_status"); //结算对象类型
      this.getConfDictValDownList("settlement_method");
    },
    // 费型类型下拉列表
    itemCategorChoose(categoryName) {
      this.$API
        .itemCategorChoose({ categoryName: categoryName })
        .then((res) => {
          this.categoryNameList = res.data.result || [];
        });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "package_name") {
            // 包装
            this.packageNameList = arrs;
            this.goodsInfoList[0].itemReqs[0].packageNameList = arrs;
          }
          if (dictType == "waybill_type") {
            // 货物类型
            this.waybillTypeList = arrs;
          }
          if (dictType == "rn_order_require") {
            // 回单类型
            this.rnrderRequireList = arrs;
          }
          if (dictType == "send_method") {
            // 获取送货方式列表
            this.sendMethodList = arrs;
          }
          if (dictType == "receive_method") {
            // 获取收货方式列表
            this.ReceivingMethodList = arrs;
          }
          if (dictType == "transport_method") {
            // 获取运输方式列表
            this.transportModeList = arrs;
          }
          if (dictType == "object_status") {
            // 获取结算对象类型
            this.objectStatusList = arrs || [];

            //
          }
          if (dictType == "settlement_method") {
            // 获取付款方式
            this.settlementMethodList = arrs;
          }
        });
    },
    // 删除应付
    delIconsYF(idx) {
      this.$confirm("确定要删除该行信息吗?", "提示:")
        .then(() => {
          let datas = JSON.parse(JSON.stringify(this.tableData51)) || [];
          let delTb51 = JSON.parse(JSON.stringify(this.delTb51)) || [];
          if (datas[idx].operationType !== "ADD") {
            datas[idx].operationType = "DEL";
            delTb51.push(datas[idx]);
            this.delTb51 = delTb51;
          }
          datas.splice(idx, 1);
          this.tableData51 = datas;
          this.$emit("delIconsYF", this.delTb51, this.tableData51);
        })
        .catch(() => {});
    },
    // 删除应收
    delIconsYS(idx) {
      this.$confirm("确定要删除该行信息吗?", "提示:")
        .then(() => {
          let datas = JSON.parse(JSON.stringify(this.tableData52)) || [];
          let delTb52 = JSON.parse(JSON.stringify(this.delTb52)) || [];
          if (datas[idx].operationType !== "ADD") {
            datas[idx].operationType = "DEL";
            delTb52.push(datas[idx]);
            this.delTb52 = delTb52;
          }
          datas.splice(idx, 1);
          this.tableData52 = datas;
          this.$emit("delIconsYS", this.delTb52, this.tableData52);
        })
        .catch(() => {});
    },

    // 表格选择事件(第五步,应付)
    handleSelectionChange51(e) {
      this.selectTableData51 = e;
    },
    // 表格选择事件(第五步,应收)
    handleSelectionChange52(e) {
      this.selectTableData52 = e;
    },

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        amount: "",
        inoutStatus: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethodConfDictName: "", //付款方式名称(我自己加的)
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        console.log("valid", valid);
        if (valid) {
          let objs = JSON.parse(JSON.stringify(this.dialogForm));
          let tableData51 = JSON.parse(JSON.stringify(this.tableData51));
          let tableData52 = JSON.parse(JSON.stringify(this.tableData52));

          if (this.dialogType == "add") {
            objs.operationType = "ADD";
            if (this.tableType == "yf") {
              tableData51.push(objs);
            } else {
              tableData52.push(objs);
            }
          } else {
            //
            console.log(this.editIdx);
            if (this.tableType == "yf") {
              tableData51[this.editIdx] = objs;
            } else {
              tableData52[this.editIdx] = objs;
            }
          }
          this.tableData51 = tableData51;
          this.tableData52 = tableData52;
          this.isShowDialog = false;
          this.$emit("diaConfirmBtnS", this.tableData51, this.tableData52);
        }
      });
    },
  },
};
</script>
<style scoped lang='less'>
.iconsRight10 {
  margin-right: 10px;
}
.iconsbtns {
  font-size: 26px;
  cursor: pointer;
}

// 查询条件边框线
@borderColor: #cccccc;
.h3title {
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid @borderColor;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}
</style>